@switch (route) {
  @case (ROUTES.CREATE) {
    <trade-multi-order-create [instruments]="facade.multiOrderInstruments$ | async" (goNext)="route = ROUTES.CONFIRM" />
  }
  @case (ROUTES.CONFIRM) {
    <trade-multi-order-confirm (goBack)="route = ROUTES.CREATE" (goNext)="route = ROUTES.SUCCESS" />
  }
  @case (ROUTES.SUCCESS) {
    <trade-multi-order-success />
  }
}
